
import React from 'react';

export const BenefitsSection: React.FC = () => {
  const benefits = [
    {
      icon: 'ri-money-pound-circle-line',
      title: 'Save up to 40% on heating bills',
      description: 'with professional insulation'
    },
    {
      icon: 'ri-time-line',
      title: 'Complete installation',
      description: 'in just 1-2 days'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'Flexible payment',
      description: 'options available'
    }
  ];

  return (
    <section className="py-16 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-emerald-600 rounded-full flex items-center justify-center">
                <i className={`${benefit.icon} text-2xl`}></i>
              </div>
              <div className="text-lg font-semibold">
                <strong>{benefit.title}</strong> {benefit.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
